<template>
  <div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <div id="duty_note">
      <div>
        <h4 class="cen">本周值日安排</h4>
      </div>

      <div id="pre_tab" class="pre_tab">
        <table class="dataintable">
          <tr class="tab_header">
            <td>ID</td>
            <td v-for="(t,index) in duty_th" :key="index" class="css-tishi">
              <a href="#">{{t.name}} <span>{{t.name}} </span></a>
            </td>
          </tr>

          <tr v-for="data_tr in duty_td">
            <!-- <a href="#"> -->
            <td v-for="(d,index) in data_tr" :key="index">
              <a href="#">{{d.val}}</a>
            </td>
            <!-- </a> -->
          </tr>
        </table>
      </div>

      <div class="duty_note" v-html="duty_note"></div>
    </div>
    <div class="duty_card">
      <span v-for="(item,index) in duty_card" :key="index" :style="{background:item.col }">
        {{item.val}}
      </span>
      <button class="pre_btn_ok" @click="UpdateMethod">
        确认查看
      </button>
    </div>
  </div>
</template>

<script>
  import api from '@/utils/type.js'
  import {
    GetShort,
    SetShort,
    ChangeSpecial,
    BackSpecial
  } from '@/utils/localstore.js';
  import {
    Method_EasySelect,
    Method_EasyAdd
  } from '@/utils/loadhttpdata.js';

  import {
    base_decode,
    base_encode
  } from '@/utils/base64.js';

  import {
    RandomColor
  } from '@/utils/method.js'


  export default {
    name: "zhiri",
    data() {
      return {
        element_loading: false,
        duty_th: [],
        duty_td: [],

        duty_note: '',
        duty_card: [],
      };
    },
    created: function() {
      this.loaddata();
    },
    methods: {
      loaddata: async function() {
        let res = [];
        this.element_loading = true;
        res = await this.loadDutyName();

        this.element_loading = false;
        if (res.status != '1') {
          this.$message({
            message: '值日表项目' + res.msg,
            type: 'warning'
          });
          return;
        }
        this.duty_th = [];
        this.duty_th.push({
          "id": "0",
          "name": "项目"
        })
        for (let i = 0; i < res.data.length; i++) {
          let o = {};
          o.id = i + 1;
          o.name = res.data[i].val;
          this.duty_th.push(o);
        }
        // console.log(this.duty_th);

        this.LoadMethod('exp_per_week', 'weekday');
        this.LoadMethod('exp_per_note', 'per_note');
        this.LoadMethod('exp_per_card', 'per_card');
        this.LoadMethod('exp_br_cast', 'broadcast');
      },
      LoadMethod: function(action, type) {

        this.$post(
          api.http_method, Method_EasySelect('data_' + action, '', '', type)
        ).then(res => {

          res = JSON.parse(res);
          // console.log(res);
          if (res.data.status == 1) {
            let t = res.data.data;
            if (type == 'weekday') {
              // console.log(t);
              let temp_list = [];
              for (let i = 0; i < t.length; i++) {
                let arr = [];
                for (let j in t[i]) {
                  // console.log('key=' + j);       //输出key
                  // console.log('val=' + t[i][j]); //输出key对应的value
                  let o = {};
                  o.key = j;
                  o.val = t[i][j];
                  arr.push(o);
                }
                temp_list.push(arr);
              }

              this.duty_td = [];
              this.duty_td = temp_list;
            } else if (type == 'per_note') {
              this.duty_note = '';
              console.log(this.duty_note);
              let str = '';
              str = base_decode(t[0].p_note);
              // let arr = str.split('\r\n');
              let arr = str.split('\n');
              let str2 = '';
              for (let i = 0; i < arr.length; i++) {
                str2 = str2 + arr[i] + '<br>';
              }
              // console.log(str2);
              this.duty_note = str2;
            } else if (type == 'per_card') {
              // console.log(t);
              this.duty_card = [];
              for (let i = 0; i < t.length; i++) {
                let o = {};
                o.id = t[i].id;
                o.val = t[i].user_card;
                o.col = RandomColor();
                this.duty_card.push(o);
              }
            } else if (type == 'broadcast') {

              this.list_broadcast = [];
              for (let i = 0; i < t.length; i++) {
                let o = {};
                o.id = t[i].id;
                o.br_date = t[i].br_date;
                o.br_type = t[i].br_type;
                o.f_id = t[i].f_id;
                o.br_data = t[i].br_data;
                o.f_url = BackSpecial(t[i].f_url);
                o.sys_date = t[i].sys_date;
                o.col = RandomColor();
                this.list_broadcast.push(o);
              }
            } else {
              this.$message({
                message: '参数=' + type + '没有配置相关方法',
                type: 'warning'
              });
            }

          }
        });
      },
      loadDutyName: function(action, type) {
        let that = this;
        return new Promise((resolve, reject) => {
          // console.log(menuvalue);
          that.$post(
            api.http_method,
            Method_EasySelect('data_exp_per_class', '', '', 'dutyok')
          ).then(res => {
            res = JSON.parse(res);
            // console.log(res.data);

            resolve(res.data)
          });
        })
      },
      UpdateMethod: function() {
        this.$post(
          api.http_method, Method_EasyAdd('data_exp_dutycard', 'card')
        ).then(res => {

          res = JSON.parse(res);
          if (res.data.status == 1) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            });
            this.LoadMethod('exp_per_card', 'per_card');
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },

    }
  };
</script>


<style scoped="scoped">
  .pre_tab {
    display: inline-block;
    text-align: center;
    max-height: 60vh;
    overflow: auto;
  }

  .dataintable tr th:nth-child(1),
  .dataintable tr td:nth-child(1) {
    display: none;
  }

  .dataintable tr th:nth-child(2),
  .dataintable tr td:nth-child(2) {
    min-width: 64px;
    width: 64px;
    max-width: 64px;
    text-align: center;
  }

  a {
    /* display: block; */
    height: 100%;
    text-decoration: none;
    color: #333;
  }

  .pre_dataintable tr>td>a:focus {
    background: #92a4f3 !important;
  }

  .duty_note {
    padding-left: 5px;
    padding-right: 5px;
    text-align: left;
    /* display: none; */
  }

  .duty_btn {
    text-align: right;
  }

  .duty_card {
    text-align: left;
  }

  .duty_card span {
    display: inline-block;
    border-radius: 5px;
    padding: 2px 4px;

    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #000000;

    margin-left: 5px;
  }

  .tab_header td {
    /* 纵向渐变 */
    /* Safari 5.1 - 6.0 */
    background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
    /* Opera 11.1 - 12.0 */
    background: -o-linear-gradient(#3da5d9, #a2d2ff);
    /* Firefox 3.6 - 15 */
    background: -moz-linear-gradient(#3da5d9, #a2d2ff);
    /* 标准的语法（必须放在最后） */
    background: linear-gradient(#3da5d9, #a2d2ff);
    text-align: center;
    color: #000000;
    font-size: 14px;
    font-weight: 400;
  }
</style>
